import * as React from "react"
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { isLoadingCommonFilters } from "@signals"
import { productDetailsEvolutionTableCurrentData, productDetailsEvolutionTableDates } from "../@signals"
import { skuColumn, retailerColumn, priceColumn, sellerColumn } from "./columns"
import { formatDate } from "@ui-seeker/utils"


const HEIGHT = 500

export default function MarketPlacesProductDetailsEvolutionTable() {
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!productDetailsEvolutionTableCurrentData.value.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Price evolution table" />}
		data={productDetailsEvolutionTableCurrentData.value}
		columns={[
			retailerColumn(productDetailsEvolutionTableDates.value[productDetailsEvolutionTableDates.value.length-1]), 
			skuColumn(),
			sellerColumn(),
			...productDetailsEvolutionTableDates.value.map(d =>
				priceColumn(d, formatDate(d, { isString: true }))
			),
			priceColumn('minPrice', 'Min price'),
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [5, 10]
		}}
	/>
}